import request from "@/utils/request";
export function fetchList(data) {
  return request({
    url: "/whg-park/api/report/orderItemReport",
    method: "post",
    data: data
  });
}